// Two-line labels for the category buttons in the header (small line on top, main word below).
export default {
  rail: {
    categories: {
      all: { top: "Toutes les", bottom: "Excursions" },
      escunas: { top: "Excursions en", bottom: "Goélette" },
      privadas: { top: "Bateaux et Goélettes", bottom: "Privés" },
      compartilhadas: { top: "Bateaux", bottom: "Partagés" },
      jeep: { top: "Excursions en", bottom: "Jeep" },
      bolivia: { top: "Expédition", bottom: "Bolivie" },
    },
  },
};
